export const gbpToPence = (value) => {
    const pounds = Number.parseFloat(value);
    if (Number.isNaN(pounds)) {
        return null;
    }
    return Math.trunc(pounds * 100);
};
//# sourceMappingURL=gbpStringToPence.js.map